// src/pages/Place.tsx (You might want to rename this file to Places.tsx)
import React, { useEffect, useState } from 'react';
import './Place.css';
import { getPlaces } from '../queries/getPlaces'; // Import the function
import { Place } from '../types'; // Import the singular type 'Place'

const Places: React.FC = () => {
  // State holds an array of 'Place'
  const [places, setPlaces] = useState<Place[]>([]);

  useEffect(() => {
    async function fetchPlaces() {
      const data = await getPlaces();
      setPlaces(data);
    }
    fetchPlaces();
  }, []);

  if (places.length === 0) return <div>Loading...</div>;

  return (
    <div className="page-container">
      <div className="quote">
        <p>A glimpse into my travel experiences across Canada.</p>
      </div>

      <div className="places-grid">
        {places.map((place, index) => (
          // Use place.title as key if available and unique, otherwise index is fine
          <div key={index} className="place-card" style={{ animationDelay: `${index * 0.2}s` }}>
            <img src={place.image.url} alt={place.title} className="place-image" />
            <h3 className="place-title">{place.title}</h3>
            <p className="place-desc">{place.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Places;